import { action, computed, makeAutoObservable, observable } from 'mobx';
import React, { ReactNode } from 'react';
import { ClipLoader } from 'react-spinners';
import { LoadingWrapper } from '../styles';
class Loader {
  @observable public showLoader: boolean;
  @observable public height?: string;
  @observable public customHeight?: string;
  constructor(showLoader: boolean = false, height: string = '', customHeight?: string) {
    this.showLoader = showLoader;
    this.height = height;
    this.customHeight = customHeight;
    makeAutoObservable(this);
  }

  @action
  public show(): void {
    this.showLoader = true;
  }

  @action
  public hide(): void {
    this.showLoader = false;
  }

  @computed
  public get loaderComponent(): ReactNode {
    return this.showLoader ? (
      <LoadingWrapper height={this.height} customHeight={this.customHeight}>
        <ClipLoader color={'green'} loading={true} size={60} />
      </LoadingWrapper>
    ) : null;
  }
}

export default Loader;
